export default __webpack_public_path__ + "static/media/img (3).a5d3c973.jpg";